"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBadgeColors = exports.SHADE_MAP = void 0;
var variables_1 = require("../../../style/variables");
exports.SHADE_MAP = {
    primary: variables_1.ThemeColor.Primary,
    error: variables_1.ThemeColor.Error,
    success: variables_1.ThemeColor.Success,
    warning: variables_1.ThemeColor.Warning,
    gray: variables_1.RootColor.Gray,
    orange: variables_1.RootColor.Orange,
    pink: variables_1.RootColor.Pink,
    teal: variables_1.RootColor.Teal,
    violet: variables_1.RootColor.Violet,
};
var COLOR_CONFIG_MAP = {
    primary: {
        color: variables_1.ThemeColor.Primary,
        overrides: {
            dark: {
                disabled: {
                    color: 'LIGHT_3',
                    iconColor: 'LIGHT_3',
                },
            },
            light: {
                disabled: {
                    color: 'LIGHT_3',
                    iconColor: 'LIGHT_3',
                },
            },
        },
    },
    error: {
        color: variables_1.ThemeColor.Error,
    },
    success: {
        color: variables_1.ThemeColor.Success,
    },
    warning: {
        color: variables_1.ThemeColor.Warning,
        overrides: {
            dark: {
                disabled: {
                    color: 'LIGHT_1',
                    iconColor: 'LIGHT_1',
                },
            },
            light: {
                disabled: {
                    color: 'LIGHT_1',
                    iconColor: 'LIGHT_1',
                },
            },
        },
    },
    gray: {
        color: variables_1.RootColor.Gray,
        overrides: {
            dark: {
                disabled: {
                    backgroundColor: 'LIGHT_5',
                    color: 'LIGHT_1',
                    iconColor: 'LIGHT_1',
                    dotColor: 'LIGHT_3',
                },
            },
            light: {
                default: {
                    backgroundColor: 'LIGHT_4',
                },
                disabled: {
                    backgroundColor: 'LIGHT_5',
                    color: 'LIGHT_1',
                    iconColor: 'LIGHT_1',
                    dotColor: 'LIGHT_3',
                },
            },
        },
    },
    orange: {
        color: variables_1.RootColor.Orange,
    },
    pink: {
        color: variables_1.RootColor.Pink,
    },
    teal: {
        color: variables_1.RootColor.Teal,
        overrides: {
            dark: {
                disabled: {
                    color: 'LIGHT_3',
                    iconColor: 'LIGHT_3',
                },
            },
            light: {
                disabled: {
                    color: 'LIGHT_3',
                    iconColor: 'LIGHT_3',
                },
            },
        },
    },
    violet: {
        color: variables_1.RootColor.Violet,
    },
};
var getLightBadgeColors = function (config, disabled) {
    var _a, _b, _c, _d;
    if (disabled) {
        var overrides_1 = (_b = (_a = config.overrides) === null || _a === void 0 ? void 0 : _a.light) === null || _b === void 0 ? void 0 : _b.disabled;
        return {
            backgroundColor: "var(" + config.color[(overrides_1 === null || overrides_1 === void 0 ? void 0 : overrides_1.backgroundColor) || 'LIGHT_6'] + ")",
            color: "var(" + config.color[(overrides_1 === null || overrides_1 === void 0 ? void 0 : overrides_1.color) || 'LIGHT_2'] + ")",
            iconColor: "var(" + config.color[(overrides_1 === null || overrides_1 === void 0 ? void 0 : overrides_1.iconColor) || 'LIGHT_2'] + ")",
            dotColor: "var(" + config.color[(overrides_1 === null || overrides_1 === void 0 ? void 0 : overrides_1.dotColor) || 'LIGHT_4'] + ")",
        };
    }
    var overrides = (_d = (_c = config.overrides) === null || _c === void 0 ? void 0 : _c.light) === null || _d === void 0 ? void 0 : _d.default;
    return {
        backgroundColor: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.backgroundColor) || 'LIGHT_5'] + ")",
        color: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.color) || 'DARK_2'] + ")",
        iconColor: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.iconColor) || 'DEFAULT'] + ")",
        dotColor: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.dotColor) || 'DEFAULT'] + ")",
    };
};
var getDarkBadgeColors = function (config, disabled) {
    var _a, _b, _c, _d;
    if (disabled) {
        var overrides_2 = (_b = (_a = config.overrides) === null || _a === void 0 ? void 0 : _a.dark) === null || _b === void 0 ? void 0 : _b.disabled;
        return {
            backgroundColor: "var(" + config.color[(overrides_2 === null || overrides_2 === void 0 ? void 0 : overrides_2.backgroundColor) || 'LIGHT_6'] + ")",
            color: "var(" + config.color[(overrides_2 === null || overrides_2 === void 0 ? void 0 : overrides_2.color) || 'LIGHT_2'] + ")",
            iconColor: "var(" + config.color[(overrides_2 === null || overrides_2 === void 0 ? void 0 : overrides_2.iconColor) || 'LIGHT_2'] + ")",
            dotColor: "var(" + config.color[(overrides_2 === null || overrides_2 === void 0 ? void 0 : overrides_2.dotColor) || 'LIGHT_4'] + ")",
        };
    }
    var overrides = (_d = (_c = config.overrides) === null || _c === void 0 ? void 0 : _c.dark) === null || _d === void 0 ? void 0 : _d.default;
    return {
        backgroundColor: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.backgroundColor) || 'DEFAULT'] + ")",
        color: "var(" + ((overrides === null || overrides === void 0 ? void 0 : overrides.color) ? config.color[overrides === null || overrides === void 0 ? void 0 : overrides.color] : variables_1.RootColor.White) + ")",
        iconColor: "var(" + ((overrides === null || overrides === void 0 ? void 0 : overrides.iconColor) ? config.color[overrides === null || overrides === void 0 ? void 0 : overrides.iconColor] : variables_1.RootColor.White) + ")",
        dotColor: "var(" + config.color[(overrides === null || overrides === void 0 ? void 0 : overrides.dotColor) || 'LIGHT_3'] + ")",
    };
};
var getBadgeColors = function (theme, color, disabled) {
    var colorConfig = COLOR_CONFIG_MAP[color];
    switch (theme) {
        case 'dark':
            return getDarkBadgeColors(colorConfig, disabled);
        case 'light':
            return getLightBadgeColors(colorConfig, disabled);
    }
};
exports.getBadgeColors = getBadgeColors;
